import { CARET_PLACEMENTS, Checkbox, Icon, Text, Tooltip } from '@afterpaytouch/core'
import clsx from 'clsx'
import { useTranslation } from '../../utils/convergence'
import React, { FunctionComponent, ReactNode, useRef, useState } from 'react'
import styles from './styles.module.css'
import { useCheckoutSizes } from '../../utils/responsive'
import { useIsConsumerLendingOrder } from '../../state'
import { useMonitoringWithEnduringEventProperties } from '../../integrations/monitoring'
import { TrackingEvent } from '../../model/monitoring'
import { useGetAutoPayStatusChangeHandler, useGetIsAutoPayAgreed } from './hooks'

// Used for CL summary only at the moment
export const AutopayToggle: FunctionComponent = () => {
  const { t } = useTranslation()
  const { checkboxSize, smallTextSize, textSize } = useCheckoutSizes()
  const [showTooltip, setShowTooltip] = useState(false)
  const buttonRef = useRef(null)
  const { logEvent } = useMonitoringWithEnduringEventProperties()
  const isConsumerLendingOrder = useIsConsumerLendingOrder()
  const autoPayChecked = useGetIsAutoPayAgreed()
  const id = 'autopay-tooltip'
  const onChangeHandler = useGetAutoPayStatusChangeHandler('event')

  const toggleTooltip = (): void => {
    logEvent(TrackingEvent.PRESSED_SUMMARY_PAGE_AUTOPAY_INFO_ICON)
    setShowTooltip(!showTooltip)
  }
  const handleClose = (): void => {
    setShowTooltip(false)
  }

  const toolTip = (): ReactNode => <Text size={textSize}>{t('consumerLending:autopay.autopayHelp')}</Text>

  const renderCheckboxLabel = (): ReactNode => {
    return (
      <Text size={smallTextSize} renderAs={'span'} bold>
        {autoPayChecked ? 'On' : 'Off'}
      </Text>
    )
  }

  if (!isConsumerLendingOrder) {
    return null
  }

  return (
    <div className={clsx(styles.wrapper)}>
      <div>
        <Text size={smallTextSize} renderAs={'span'} bold>
          {t('consumerLending:autopay:name')}
        </Text>
        <button
          type='button'
          className={styles.triggerButton}
          onClick={toggleTooltip}
          ref={buttonRef}
          data-testid='autopay-info-button'
          aria-label={t('consumerLending:autopay:autopayInfo')}
          aria-describedby={id}
          aria-expanded={showTooltip}
        >
          <Icon.Info size='Small' />
        </button>
      </div>
      <div className={styles.toggle}>
        <Checkbox
          label={renderCheckboxLabel()}
          size={checkboxSize}
          onChange={onChangeHandler}
          defaultChecked={autoPayChecked}
          name='autopayToggle'
          id='autopay'
          testNameSpace='autopay-toggle'
          kind='Toggle'
          reversed
        />
      </div>
      {showTooltip && (
        <div className={styles.tooltipWrapper}>
          <Tooltip
            id={id}
            triggerRef={buttonRef}
            caretPlacement={CARET_PLACEMENTS.TOP_START}
            testNameSpace='tooltip'
            usePortal={false}
            content={toolTip()}
            skidding={120}
            hasCaret={true}
            onClose={handleClose}
          />
        </div>
      )}
    </div>
  )
}
